module.exports = __webpack_public_path__ + "img/acediamonds.94971a7d.png";